/* Cursor-tracked 3D tilt + glare for the homepage tiles (group blocks inside
   #shopify-section-section_tiles). Desktop / fine-pointer only; reduced-motion safe. */
(function () {
  if (!window.matchMedia) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var STYLE_ID = 'tiles-fx-style';
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.tiles-glare{position:absolute;inset:0;z-index:5;pointer-events:none;opacity:0;' +
      'transition:opacity .3s ease;mix-blend-mode:soft-light;' +
      'background:radial-gradient(240px circle at var(--gx,50%) var(--gy,50%),rgba(255,255,255,.5),transparent 60%);}';
    document.head.appendChild(s);
  }

  function bindTile(tile) {
    if (tile.__tiltBound) return;
    tile.__tiltBound = true;
    tile.style.transformStyle = 'preserve-3d';
    tile.style.transition = 'transform 0.45s cubic-bezier(0.2, 0.7, 0.2, 1)';
    tile.style.willChange = 'transform';

    var glare = document.createElement('span');
    glare.className = 'tiles-glare';
    glare.setAttribute('aria-hidden', 'true');
    tile.appendChild(glare);

    tile.addEventListener('pointermove', function (e) {
      var r = tile.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      var rx = (0.5 - py) * 8;
      var ry = (px - 0.5) * 10;
      tile.style.transition = 'transform 0.08s linear';
      tile.style.transform = 'perspective(1000px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.02)';
      glare.style.setProperty('--gx', (px * 100) + '%');
      glare.style.setProperty('--gy', (py * 100) + '%');
      glare.style.opacity = '1';
    });
    tile.addEventListener('pointerleave', function () {
      tile.style.transition = 'transform 0.45s cubic-bezier(0.2, 0.7, 0.2, 1)';
      tile.style.transform = '';
      glare.style.opacity = '0';
    });
  }

  function run() {
    var host = document.getElementById('shopify-section-section_tiles') ||
      document.querySelector('[id^="shopify-section-"][id$="__section_tiles"]');
    if (!host) return;
    injectStyle();
    var tiles = host.querySelectorAll('.group-block');
    for (var i = 0; i < tiles.length; i++) {
      // Skip nested groups — only tilt the outer tile.
      if (!tiles[i].parentElement.closest('.group-block')) bindTile(tiles[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
